import { Component, input, output } from '@angular/core';
import { CardComponent } from '../card.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { IconComponent } from 'app/shared/icon/icon.component';
import { provideIcons } from '@ng-icons/core';
import { heroChevronRight, heroGlobeAlt, heroTrash, heroUserCircle } from '@ng-icons/heroicons/outline';

@Component({
  selector: 'app-card-item',
  standalone: true,
  imports: [CardComponent, MatCheckboxModule, IconComponent],
  templateUrl: './card-item.component.html',
  styleUrls: ['./card-item.component.scss'],
  providers: [provideIcons({ heroTrash, heroChevronRight, heroUserCircle, heroGlobeAlt })],
  host: {
    class: 'flex w-full cursor-pointer',
  },
})
export class CardItemComponent {
  isCheckbox = input(false);
  isChecked = input(false);
  isDeleteIcon = input(false);
  isChevronIcon = input(false);
  isGray = input(false);
  icon = input<string>();
  delete = output();

  onDelete(event: MouseEvent) {
    event.stopPropagation();
    this.delete.emit();
  }
}
